import { createSlice } from '@reduxjs/toolkit';
import { Training , trainingState } from './trainingTypes';
import { createTraining , updatetraining , fetchAlltraininglist, gettraininglistById, deletetraininglistById } from './trainingAction';


const initialState : trainingState = {
  Training : [],
  selected: undefined,
  loading: false,
  error: undefined,
}


const trainingSlice = createSlice({
    name : 'training',
    initialState,
    reducers: {},
    extraReducers : (builder) => {
        builder 
          .addCase(createTraining.pending,(state) =>{
            state.loading=true ;
            state.error = undefined;
          })
        .addCase(createTraining.fulfilled, (state, action) => {
                  state.loading = false;
                  state.Training.push(action.payload.data)
                })
         .addCase(createTraining.rejected, (state, action) => {
                  state.loading = false;
                  state.error = action.payload as string;
         })

         //update
         .addCase(updatetraining.pending,(state , action) =>{
                 state.loading=true ;
                 state.error = undefined;
         })
         .addCase(updatetraining.fulfilled, (state, action) => {
               state.loading = false;
               const index = state.Training.findIndex((d : any) => d.Id === action.payload.Id);
               if (index !== -1) {
                   state.Training[index] = action.payload;
               }
        })
         .addCase(updatetraining.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload as string;
       })

        //fetch all
       .addCase(fetchAlltraininglist.pending,(state , action) =>{
        state.loading=true ;
        state.error = undefined;
      })
      .addCase(fetchAlltraininglist.fulfilled, (state, action) => {
      state.loading = false;
      state.Training=action.payload.data
      })
     .addCase(fetchAlltraininglist.rejected, (state, action) => {
     state.loading = false;
     state.error = action.payload as string;
     })

     // Fetch  by ID
     .addCase(gettraininglistById.pending, (state) => {
       state.loading = true;
       state.error = undefined;
       })
       .addCase(gettraininglistById.fulfilled, (state, action) => {
           state.loading = false;
           state.selected = action.payload;
       })
       .addCase(gettraininglistById.rejected, (state, action) => {
           state.loading = false;
           state.error = action.payload as string;
       })


       .addCase(deletetraininglistById.pending, (state) => {
            state.loading = true;
            state.error = undefined;
        })
        .addCase(deletetraininglistById.fulfilled, (state, action) => {
             state.loading = false;
             state.Training = state.Training.filter((d : any) => d.Id !== action.payload);
         })
         .addCase(deletetraininglistById.rejected, (state, action) => {
            state.loading = false;
            state.error= action.payload as string;
         })
       
    }
})


export default trainingSlice.reducer;
